module.exports = __webpack_public_path__ + "static/media/lighttheme.6132aa27.png";